import * as THREE from "three";
import { useEffect, useRef } from "react";
import { Line2 } from "three/examples/jsm/lines/Line2";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial";

export function DimensionLine({
  params,
  line_width,
  start,
  end,
  visible,
  lineStyle = "solid",
  scaleFactor,
}) {
  const lineRef = useRef(); // Reference for the group

  // Calculate points on every render
  const points = [start.x, start.y, start.z, end.x, end.y, end.z];

  // Create a new geometry object on every render
  const geometry = new LineGeometry();
  geometry.setPositions(points);

  // Create a new material object on every render
  const material = new LineMaterial({
    color: params.line_colour,
    opacity: params.line_opacity,
    linewidth: line_width,
    resolution: new THREE.Vector2(params.canvas_width, params.canvas_height),
    transparent: true,
  });

  // Configure dashed line if necessary
  if (lineStyle === "dotted") {
    material.dashed = true;
    material.dashSize = 1 / scaleFactor;
    material.gapSize = 0.5 / scaleFactor;
    material.defines.USE_DASH = ""; // Enable dashed shader
  }

  // Update resolution whenever params change
  useEffect(() => {
    material.resolution.set(params.canvas_width, params.canvas_height);
  }, [params]);

  // Handle line creation and updates
  useEffect(() => {
    if (lineRef.current) {
      // Clear previous children to avoid duplicates on rerenders
      lineRef.current.clear();

      console.log("material opacity:", material.opacity);

      // Create a new Line2 object
      const line = new Line2(geometry, material);

      // Compute line distances (required for dashed lines)
      line.computeLineDistances();

      lineRef.current.add(line);
    }
  });

  return <group ref={lineRef} visible={visible} />;
}